import { Box, Button, Dialog, DialogContent, DialogTitle, Link, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { buttonStyle, errorTextStyle, titleStyle } from '../../../utils/commonCSS'
import { blueTextColor, darkGrey, headingBlue, maroon, mediumGrey, textColor } from '../../../assets/colors'
import { ContentCopy } from '@mui/icons-material'
import CustomSnackBar from '../../CustomComponents/CustomSnackBar'
import { useDispatch } from 'react-redux'
import { showSnackBar } from '../../CustomComponents/CustomComponentsSlice'
import { updateTaskStatus } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'

const TaskDetailsDialog = (props) => {

  const navigate = useNavigate()

  const dispatch = useDispatch()
  const [doneMarked, setDoneMarked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdateTaskStatus = () => {
    setIsLoading(() => true)
    let options = {
      url: updateTaskStatus,
      method: 'PUT',
      payload: {
        _id: props?.data?._id,
        taskStatus: 'done'
      },
      headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }
    HttpService(options).then(() => {
      setIsLoading(() => false)
      dispatch(showSnackBar({message: 'Task Status Updated.'}))
      props?.updateDialogStatus(false, true)
    }).catch(err => {
      if (err?.status === 403) {
					localStorage.clear()
          setIsLoading(false)  
					navigate('/signUp')
				} else {
					console.log('Error in updating task Status: ', err)
					dispatch(showSnackBar({message: 'Error in Updating. Please Contact Support.'}))
					setIsLoading(false)
				}
    })
  }

  useEffect(() => {
    setDoneMarked(() => false)
  }, [props?.dialogStatus])

  return (
    <>
      <Dialog maxWidth='xs' fullWidth open={props?.dialogStatus} onClose={() => props?.updateDialogStatus(false)}>
        <DialogTitle style={titleStyle}>
          Task Details
        </DialogTitle>
        <DialogContent>
          <>
          {isLoading && <Loader></Loader>}
          {!doneMarked && 
            <>
              <Box style={{padding: '1.5rem 0.1rem 0.5rem 0.1rem'}}>
                <Typography style={{color: darkGrey}}>Task Link:</Typography>
                <Box style={{border: `1px solid ${mediumGrey}`, padding: '0.1rem 0.3rem 0.1rem 0.3rem',
                    borderRadius: '0.4rem'
                }}>
                  <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0.15rem'}}>
                    {/* <Typography style={{textOverflow: "ellipsis", overflow: 'hidden', color: headingBlue}}
                      onClick={() => {
                        
                      }}
                    > */}
                    <Link href={props?.data?.taskLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >{props?.data?.taskLink}
                    </Link>
                      {}
                    {/* </Typography> */}
                    <ContentCopy onClick = {async () => {
                      await navigator.clipboard.writeText(props?.data?.taskLink)
                      dispatch(showSnackBar({message: 'Link Copied'}))
                    }}></ContentCopy>
                  </Box>
                </Box>
              </Box>
              <Box style={{padding: '0.5rem 0.1rem 0.5rem 0.1rem'}}>
              <Typography style={{color: darkGrey}}>Task Caption:</Typography>
              <Box style={{border: `1px solid ${mediumGrey}`, padding: '0.1rem 0.3rem 0.1rem 0.3rem',
                  borderRadius: '0.4rem'
              }}>
                <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '0.15rem'}}>
                  <Typography style={{textOverflow: "ellipsis", overflow: 'hidden', color: headingBlue}}>{props?.data?.taskCaption}</Typography>
                  <ContentCopy onClick = {async () => {
                    await navigator.clipboard.writeText(props?.data?.taskCaption)
                    dispatch(showSnackBar({message: 'Caption Copied'}))
                  }}></ContentCopy>
                </Box>
              </Box>
              </Box>
              <Box style={{display: 'flex', justifyContent: 'center', }}>
                <Button style={{...buttonStyle, opacity: props?.data?.taskStatus === 'done' ? 0.5 : 1,
                  pointerEvents: props?.data?.taskStatus === 'done' ? 'none' : 'auto' 
                }}
                  onClick={() => {
                    setDoneMarked(() => true)
                  }}
                >Mark Done</Button>
              </Box>
            </>}

            {doneMarked && 
              <>
                <Box style={{display: 'flex', padding: '0.75rem 0.25rem 0.5rem 0.25rem'}}>
                  <Typography style={{color: headingBlue}}>Are you sure you want to mark this task as done?</Typography>
                </Box>
                <Box style={{display: 'flex', justifyContent: 'flex-end', padding: '0.5rem 0.1rem 0rem 0.1rem'}}>
                  <Button style={{...buttonStyle, backgroundColor: maroon, padding: '0.1rem 0.3rem 0.1rem 0.3rem', fontSize: '0.9rem'}}
                    onClick={() => setDoneMarked(() => false)}
                  >Cancel</Button>
                  <Button style={{...buttonStyle, padding: '0.1rem 0.3rem 0.1rem 0.3rem', fontSize: '0.9rem'}}
                    onClick={() => handleUpdateTaskStatus()}
                  >Confirm</Button>
                </Box>
              </>
            }
          </>
        </DialogContent>

      </Dialog>
    </>
  )
}

export default TaskDetailsDialog
